import { computed } from "mobx";
import { useMemo } from "react";

import { TranslationStore } from "./translation-store";

export class LocalizedMoment {
  constructor(private _date: Date | string | undefined) {}

  public static create(date: Date | string | undefined) {
    return new LocalizedMoment(date);
  }

  @computed
  public get moment() {
    // Reference active language so this gets recomputed when language changes
    // Note: we are explicitely relying on a side effect of computed here
    TranslationStore.activeLanguage;
    return TranslationStore.localizedMoment(this._date);
  }

  @computed
  public get date(): Date {
    return this.moment.toDate();
  }

  @computed
  public get time(): string {
    // Explicitely omit local time to avoid AM/PM  format for english language
    return this.moment.format("HH:mm");
  }

  @computed
  public get elaborate() {
    return `${this.moment.format("ddd")} ${
      this.longDate
    } | ${this.moment.format("HH:mm")}`;
  }

  @computed
  public get timeZoneOffset() {
    return this.moment.format("Z");
  }

  @computed
  public get longDateTime(): string {
    return `${this.longDate}, ${this.time}`;
  }

  @computed
  public get shortDateTime(): string {
    return `${this.shortDate}, ${this.time}`;
  }

  @computed
  public get longDate(): string {
    return this.moment.format("LL");
  }

  @computed
  public get shortDate(): string {
    return this.moment.format("ll");
  }

  @computed
  public get monthAndYear(): string {
    return this.moment.format("MMM YYYY");
  }

  @computed
  public get day(): string {
    return this.moment.format("D");
  }

  @computed
  public get shortMonth(): string {
    return this.moment.format("MMM");
  }

  @computed
  public get fromNow(): string {
    return this.moment.fromNow();
  }
}

export const useLocalizedMoment = (date: Date | string | undefined) => {
  return useMemo(() => new LocalizedMoment(date), [date]);
};
